import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3a436b50&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3a436b50&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a436b50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\java\\project\\kaixinshequ-java\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a436b50')) {
      api.createRecord('3a436b50', component.options)
    } else {
      api.reload('3a436b50', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3a436b50&scoped=true", function () {
      api.rerender('3a436b50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/devise/index.vue"
export default component.exports